import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "ActAccessModalStepAddUsers" }
const _hoisted_2 = { class: "ActAccessContentSubSection" }
const _hoisted_3 = { class: "ActAccessModalInputFieldHint" }
const _hoisted_4 = { class: "ListOfUsersToAdd" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "InvalidInputMessage"
}
const _hoisted_7 = {
  key: 1,
  class: "ActAccessModalInputFieldHint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Add Users", -1 /* CACHED */)),
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "UsersManagementText" }, " Enter the email addresses of the users who should have access. ", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.amountOfUsersBasedSentence), 1 /* TEXT */),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actUsersToAdd, (entry, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass([
						'UserToAddBlock',
						_ctx.isEntryInvalid(entry) ? 'Invalid' : ''
					])
          }, [
            _createTextVNode(_toDisplayString(entry.value) + " ", 1 /* TEXT */),
            _createElementVNode("button", {
              class: "RemoveUserToAddButton",
              onClick: ($event: any) => (_ctx.removeUserToAdd(index))
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "lnr-cross" }, null, -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_5)
          ], 2 /* CLASS */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _createElementVNode("input", {
        ref: "addUsersInputField",
        type: "text",
        placeholder: "Enter email addresses ...",
        class: "ActAccessModalInputField",
        onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleTextInput && _ctx.handleTextInput(...args))),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.analyseTextInputForUsersToAdd && _ctx.analyseTextInputForUsersToAdd(...args)), ["enter"])),
        onPaste: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handlePastInput && _ctx.handlePastInput(...args)))
      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
      (_ctx.invalidEntriesMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.invalidEntriesMessage), 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("p", _hoisted_7, " Press Enter or Comma to add an email "))
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}